module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-shenzhen.03e3457e.png";